import { MockFactory } from '@tino-frontend/mocks'
import { PaymentLinkDetail, PaymentLinkStatus } from '@types'

export const paymentLinkDetailBaseMock = new MockFactory<PaymentLinkDetail>({
  id: 'payment_link_id',
  supplier_company_id: 'supplier_company_id',
  external_id: 'external_id_1',
  amount_cents: 500,
  merchant_document_number: '10020030020010',
  link: 'http://tino.com.br',
  link_creation_time: '2021-01-01T00:00:00.000Z',
  billing_time: '2021-01-01T00:00:00.000Z',
  status: PaymentLinkStatus.LinkSent,
  invoices: [
    {
      id: 'invoice_id',
      created_at: '2021-01-01T00:00:00.000Z',
      nfe_id: 'nfe_id',
      amount_cents: 1000,
      status: 'approved',
    },
  ],
  merchant_name: 'Merchant Name',
  phone_number: '+5511999999999',
  email: 'email@example.com',
  max_due_day: 30,
  origin: 'link-financialperson',
})
